import { ChallengeResponse } from "@Shared/schemas/challenges/challengeSchemas";
import { TFunction } from "i18next";

export function formatTimeUntil(time: Date | null, i18n: TFunction) {
  if (!time) return null;
  const timeUntil = new Date(time).getTime() - Date.now();

  const days = Math.floor(timeUntil / (24 * 60 * 60 * 1000));
  const hours = Math.floor((timeUntil % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((timeUntil % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((timeUntil % (60 * 1000)) / 1000);

  let timeValues: string[] = [];
  if (days > 0) timeValues.push(`${days}${i18n("days-extra-short")}`);
  if (hours > 0) timeValues.push(`${hours}${i18n("hours-extra-short")}`);
  if (minutes > 0 && timeValues.length < 2) timeValues.push(`${minutes}${i18n("minutes-extra-short")}`);
  if (seconds > 0 && timeValues.length < 1) timeValues.push(`${seconds}${i18n("secounds-extra-short")}`);

  return timeValues.join(" ");
}

export function challengeHasTag(challenge: ChallengeResponse, tag: string) {
  return Boolean(challenge.tags?.map((t) => t.tag).includes(tag));
}
